export function tenureText( ativoDesde ) {
  if ( !ativoDesde ) {
    return 'algum tempo'
  }
  const from = new Date( ativoDesde )
  if ( Number.isNaN( from.getTime() ) ) {
    return 'algum tempo'
  }
  const now = new Date()
  let anos = now.getFullYear() - from.getFullYear()
  let meses = now.getMonth() - from.getMonth()
  if ( now.getDate() < from.getDate() ) {
    meses -= 1
  }
  if ( meses < 0 ) {
    anos -= 1
    meses += 12
  }
  const partes = []
  if ( anos > 0 ) {
    partes.push( `${anos} ${anos === 1 ? 'ano' : 'anos'}` )
  }
  if ( meses > 0 ) {
    partes.push( `${meses} ${meses === 1 ? 'mês' : 'meses'}` )
  }
  return partes.length ? partes.join( ' e ' ) : 'poucos dias'
}

export function fmtLong( isoOuData ) {
  if ( !isoOuData ) {
    return ''
  }
  const data = new Date( isoOuData )
  if ( Number.isNaN( data.getTime() ) ) {
    return ''
  }
  const meses = [ 'janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro' ]
  return `${data.getDate()} de ${meses[ data.getMonth() ]} de ${data.getFullYear()}`
}

export function fmtMesAno( isoOuData ) {
  if ( !isoOuData ) {
    return ''
  }
  const data = new Date( isoOuData )
  if ( Number.isNaN( data.getTime() ) ) {
    return ''
  }
  const meses = [ 'janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro' ]
  return `${meses[ data.getMonth() ]}/${data.getFullYear()}`
}

export function fmtRenewFull( isoOuData ) {
  if ( !isoOuData ) {
    return ''
  }
  const data = new Date( isoOuData )
  if ( Number.isNaN( data.getTime() ) ) {
    return ''
  }
  const dia = String( data.getDate() ).padStart( 2, '0' )
  const mes = String( data.getMonth() + 1 ).padStart( 2, '0' )
  return `${dia}/${mes}/${data.getFullYear()}`
}

export function derivarCards( assinatura ) {
  const cartao = assinatura?.pagamento?.cartaoCredito
  if ( !cartao ) {
    return []
  }
  return [
    {
      'id': String( cartao.id || 'c-current' ),
      'brand': cartao.bandeira || '',
      'last4': cartao.ultimosDigitos || '',
      'exp': cartao.validade || '',
      'name': cartao.nome || ''
    }
  ]
}

export function derivarAddrs( assinatura ) {
  const endereco = assinatura?.entrega?.endereco
  if ( !endereco ) {
    return []
  }
  return [
    {
      'id': String( endereco.id || 'a-current' ),
      'cep': endereco.cep || '',
      'rua': endereco.rua || '',
      'numero': endereco.numero || '',
      'complemento': endereco.complemento || '',
      'bairro': endereco.bairro || '',
      'cidade': endereco.cidade || '',
      'uf': endereco.uf || ''
    }
  ]
}

export function derivarSituacaoCancelamento( status ) {
  if ( status === 'Cancelado' ) {
    return 'cancelada'
  }
  if ( status === 'Solicitou Cancelamento' ) {
    return 'em_processo'
  }
  return 'ativa'
}

export const EDICAO_BOOKSTER_COM_ESTORNO = 2027

export function temEstornoNoCancelamento( assinatura ) {
  return Number( assinatura?.edicaoBookster ) === EDICAO_BOOKSTER_COM_ESTORNO
}

export function derivarProximaEdicao( assinatura ) {
  const edicao = assinatura?.edicaoBookster
  return edicao ? edicao + 1 : null
}

export function derivarEdicaoRenovacao( assinatura ) {
  const edicao = assinatura?.edicaoBookster
  if ( !edicao ) {
    return null
  }
  return assinatura.podeRenovar === false ? edicao : edicao + 1
}

const MESES_ANO = 12

export function derivarValorPagoEdicaoAtual( assinatura ) {
  if ( !assinatura || assinatura.podeRenovar !== false || !assinatura.edicaoBookster ) {
    return null
  }

  const valorLiquido = Number( assinatura.valorLiquido )
  if ( !Number.isFinite( valorLiquido ) || valorLiquido <= 0 ) {
    return null
  }

  return {
    'mensal': valorLiquido / MESES_ANO,
    'totalAnual': valorLiquido
  }
}

export function derivarPay( assinatura ) {
  const metodo = assinatura?.pagamento?.metodo
  if ( metodo && String( metodo ).toUpperCase() === 'PIX' ) {
    return 'pix'
  }
  return 'card'
}
